import { gql } from '@apollo/client'

import { AccountCardsTable } from 'components/CardsView/components/CardsTable/AccountCardsTable/AccountCardsTable'

export const GetAccountDebitCardsVerbose = gql`
  query GetAccountDebitCardsVerbose($debitCardAccountUuid: ID!) {
    getDebitCardAccountV2(debitCardAccountUuid: $debitCardAccountUuid) {
      id
      status
      type
      __typename
      cards {
        ...AccountCardsTableDebitCardV2Fragment
      }
    }
    getEntity {
      __typename
      id
      canCreateCard
    }
  }

  ${AccountCardsTable.fragments.DebitCardV2}
`
